// extracted by mini-css-extract-plugin
export var closeButton = "_do-1";
export var closeX = "_do-3";
export var container = "_do-0";
export var image = "_do-2";